// removes really annoying safari auto zoom when clicking on inputs
const updateViewportMeta = () => {
  let meta = document.querySelector('meta[name="viewport"]');

  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "viewport";
    document.head.appendChild(meta);
  }

  meta.content =
    "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
};

updateViewportMeta();

// remove default margin and padding on html and body
document.documentElement.style.margin = "0";
document.documentElement.style.padding = "0";
document.body.style.margin = "0";
document.body.style.padding = "0";

// polyfill for HTMLDialogElement (safari)
if (typeof window !== "undefined") {
  if (typeof window.HTMLDialogElement === "undefined") {
    window.HTMLDialogElement = function () {};
  }
}

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initAnalytics } from "./get-a-quote/analytics/analytics";
import { theme } from "./theme";
import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "./index.css";

const fontStyle = document.createElement("style");
fontStyle.innerHTML = `
  @font-face {
    font-family: "Avenir Next";
    src: url("/fonts/avenir-next-regular.woff2") format("woff2");
    font-weight: 400;
  }
  @font-face {
    font-family: "Avenir Next";
    src: url("/fonts/avenir-next-demi.woff2") format("woff2");
    font-weight: 600;
  }
  
  /* Force it onto the container */
  #get-a-quote {
    font-family: "Avenir Next", sans-serif !important;
  }
`;
document.head.appendChild(fontStyle);

// Moves mounting to above WP's content element
const mountNode = document.getElementById("get-a-quote");
const otherElems = document.getElementById("other-elems");
const content = document.getElementById("content");

if (mountNode && content && content.parentNode) {
  content.parentNode.insertBefore(otherElems, content);
  content.parentNode.insertBefore(mountNode, content);
}

initAnalytics();

ReactDOM.createRoot(document.getElementById("get-a-quote")).render(
  <React.StrictMode>
    <MantineProvider
      theme={theme}
      cssVariablesSelector="#get-a-quote"
      getRootElement={() => document.getElementById("get-a-quote")}
      defaultProps={{
        Portal: {
          target: document.getElementById("get-a-quote"),
        },
      }}
      deduplicateCssVariables={false}
    >
      <App />
    </MantineProvider>
  </React.StrictMode>,
);
